import { useQuery } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useScopeKey } from './useScopeKey.js';

/**
 * Liste des personnes ayant initié au moins une transaction (porteur de carte
 * Qonto ou initiateur de virement), pour le filtre « Payé par ».
 * La clé commence par `['transactions']` : elle est invalidée avec les
 * transactions (une re-sync peut faire apparaître un nouveau payeur).
 */
export function useTransactionPayers() {
  const scopeKey = useScopeKey();
  return useQuery({
    queryKey: ['transactions', 'payers', scopeKey],
    queryFn: () => api.get('/transactions/payers'),
    staleTime: 60_000,
    enabled: scopeKey !== 'loading',
    select: (data) => data?.items ?? [],
  });
}
